import React, { type ReactNode, useSyncExternalStore } from 'react';

import type { ModalHost } from '../../model/modalHost';
import { getModalHostInternals } from '../../model/modalHostInternals';
import { ModalHostItem } from '../ModalHostItem/ModalHostItem';
import { ModalHostProvider } from '../ModalHostProvider/ModalHostProvider';

interface ModalHostRendererProps {
  host: ModalHost;
  fallback?: ReactNode;
}

export const ModalHostRenderer: React.FC<ModalHostRendererProps> = ({ host, fallback = null }) => {
  const { stackStore } = getModalHostInternals(host);
  const stack = useSyncExternalStore(stackStore.subscribe, stackStore.getStack);

  return (
    <ModalHostProvider host={host}>
      {stack.map(({ id, type }) => (
        <ModalHostItem
          key={id}
          host={host}
          id={id}
          type={type}
          fallback={fallback}
        />
      ))}
    </ModalHostProvider>
  );
};
